import { gql } from '@apollo/client';

import { Course } from '../../types';
import { courseFragment } from '../fragments';

export interface GetCoursesQueryResult {
  courses: Course[];
}

export const getCoursesQuery = gql`
  query GetCourseByIdQuery {
    courses @rest(type: "Course", path: "courses") {
      ...Course
    }
  }
  ${courseFragment}
`;
